import { Component, Input } from '@angular/core'

@Component({
  selector: 'lin-billing-card',
  templateUrl: './billing-card.component.html',
  styleUrls: ['./billing-card.component.scss'],
  standalone: false,
})
export class BillingCardComponent {
  @Input() label: string
}
